import React, {Component} from "react";
import SimpleModal from "../../../modules/popup/SimpleModal";
import SimpleDataTable from "../../../modules/SimpleDataTable";
import ModalContainer from "../../../modules/commons/ModalContainer";
import FlexView from "react-flexview";
import {TABLE_COLUMN_DETAIL_HISTORY_SERVICE_CONFIG} from "./config";
import {contructQueryParam, fetchDataAsync} from "../../../Services/Utils";
import Api from "../../../Services/Api";
import {HttpStatus} from "../../common/Constants";
import SimpleLoadingOverlay from "../../../modules/popup/SimpleLoadingOverlay";
import ErrorAction from "../../../Redux/ErrorRedux";
import {connect} from "react-redux";

class CustomerProfileCDBDetailHistoryService extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isExpanded: true,
            dataTable: [],
            dataTableJob: [],
            dataTablePart: [],
            tableColumns: [...TABLE_COLUMN_DETAIL_HISTORY_SERVICE_CONFIG.DATA(this.handleExpandDetail, "blue")],
            tableColumnsJob: [...TABLE_COLUMN_DETAIL_HISTORY_SERVICE_CONFIG.JOB],
            tableColumnsPart: [...TABLE_COLUMN_DETAIL_HISTORY_SERVICE_CONFIG.PART],
        }
    }

    async componentDidMount() {
        this.setState((prevValue) => ({ ...prevValue, loading: !prevValue.loading }));
        // const queryParam = contructQueryParam({customerId: this.props.id});
        await this.fetchData({
            nosin: this.props.selectedData?.nomorMesin
        });
        this.setState((prevValue) => ({ ...prevValue, loading: !prevValue.loading }));
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevState.isExpanded !== this.state.isExpanded) {
            let color = this.state.isExpanded ? "blue" : "black"
            this.setState((prevState) => ({
                ...prevState,
                tableColumns: [...TABLE_COLUMN_DETAIL_HISTORY_SERVICE_CONFIG.DATA(this.handleExpandDetail, color)],
            }))
        }
    }

    handleExpandDetail = () => {
        this.setState((prevState) => ({
            ...prevState,
            isExpanded: !prevState.isExpanded
        }))
    }

    fetchData = async (filter = {}) => {
        const responses = await Promise.all([
            fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_TRANSACTION").getDataCabangHistoryCDB,
                setError: this.props.setError,
                menuName: "CDB - Customer Profile",
                args: filter,
            }),
            fetchDataAsync({
                asyncFn: Api.create("NAGAMAS_TRANSACTION").getDetailHistoryServiceCDB,
                setError: this.props.setError,
                menuName: "CDB - Customer Profile",
                args: filter,
            })
        ]);
        console.log(responses)

        responses.forEach((response, idx) => {
            if (response.data.status !== HttpStatus.SUCCESS) this.props.onClickClose();
            this.setState((prevState) => {
                const updates = {};
                if (idx === 0) {
                    updates.dataTable = [...response.data.data];
                } else if (idx === 1) {
                    updates.dataTableJob = response.data.data.listDataJasaService;
                    updates.dataTablePart = response.data.data.listDataPartService;
                }
                return { ...prevState, ...updates };
            });
        });
    }

    render() {
        return (
            <>
                <SimpleModal
                    id="customerProfileCDBDetailHistoryService"
                    title="Detail History Service"
                    visible={this.props.visible}
                    onClickClose={() => this.props.onClickClose()}
                    content={
                        <ModalContainer>
                            <FlexView column style={{gap: 20}}>
                                <div className="txt-site txt-12 txt-main txt-bold">
                                    <h4>Data</h4>
                                </div>
                                <SimpleDataTable
                                    data={this.state.dataTable}
                                    columns={this.state.tableColumns}
                                    toCount={0}
                                    rowsPerPage={5}
                                    page={0}
                                    options={{serverSide: false}}
                                />
                                {this.state.isExpanded && (
                                    <>
                                        <div className="txt-site txt-12 txt-main txt-bold">
                                            <h4>Job / Jasa Service</h4>
                                        </div>
                                        <SimpleDataTable
                                            data={this.state.dataTableJob}
                                            columns={this.state.tableColumnsJob}
                                            toCount={0}
                                            rowsPerPage={5}
                                            page={0}
                                            options={{serverSide: false}}
                                        />
                                        <div className="txt-site txt-12 txt-main txt-bold">
                                            <h4>Part</h4>
                                        </div>
                                        <SimpleDataTable
                                            data={this.state.dataTablePart}
                                            columns={this.state.tableColumnsPart}
                                            toCount={0}
                                            rowsPerPage={5}
                                            page={0}
                                            options={{serverSide: false}}
                                        />
                                    </>
                                )}
                            </FlexView>
                        </ModalContainer>
                    }
                />

                <SimpleLoadingOverlay active={this.state.loading}/>
            </>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(CustomerProfileCDBDetailHistoryService);